import React, {useState} from 'react'
import PropTypes from 'prop-types'
import actions from 'redux-auto'

import i18n from 'i18next'
import Api from '#services/api'
import Text from '#components/a/Text'
import PrintButtonTooltip from '#components/m/PrintButtonTooltip'
import ControlsGroup from '#components/m/ControlsGroup'

import NachweisListe from './NachweisListe'
import Button from '#components/a/Button'

import {routeHelper} from '#config/routeKeys'
import UserName from '#components/a/UserName'
import {usePermissions} from '#hooks/usePermissions'
import {useNavigate} from 'react-router-dom'
import ErrorModal from '#components/m/ErrorModal'
import AzubiStatusBadge, {azubiStatus} from '#components/m/Ausbildungsnachweis/AzubiStatusBadge'

function NachweisListeAusbilderPerAzubi({
  userId,
  ausbildungsnachweise,
  maxAusbildungsnachweisNummer,
  firstname,
  lastname,
  ausbildungsberufString,
  addDetailsLink,
  testId,
  nachweisStatus,
}) {
  const [error, setError] = useState()

  const handlePrint = async (min, max, withCover) => {
    try {
      return await Api.printNachweisRangeAusbilder(userId, min, max, withCover)
    } catch (e) {
      if (e && e.message) {
        const translatedMessage = i18n.t(e.message)
        if (translatedMessage !== e.message) {
          e.message = translatedMessage
        }
        setError(e)
      } else {
        actions.error.writeError({error: e})
        throw new Error(e.message)
      }
    }
  }
  const navigate = useNavigate()
  const goToFullList = () => {
    navigate(routeHelper.ausbildungsnachweisePerUser(userId))
  }

  const permissions = usePermissions()

  const renderButtons = () => {
    if (maxAusbildungsnachweisNummer === 0) {
      return null
    }
    return (
      <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4">
        <ControlsGroup>
          {addDetailsLink && (
            <Button event={goToFullList} text={i18n.t('showAll')} variant="secondary" modifiers={['showall']} />
          )}
          {permissions.nachweis.export.multiple && (
            <PrintButtonTooltip
              maxNachweisNummer={maxAusbildungsnachweisNummer}
              minNachweisNummer={1}
              handlePrint={handlePrint}
            />
          )}
        </ControlsGroup>
      </div>
    )
  }

  const modifier = maxAusbildungsnachweisNummer === 0 ? 'none_created' : ''
  const name = `${firstname} ${lastname}`
  return (
    <>
      {error && error.message && (
        <ErrorModal
          headline={i18n.t('ausbildungsnachweis_print_error')}
          text={error.message}
          error={error}
          showModal={true}
          buttonText={i18n.t('okay')}
          onButtonClick={() => {
            setError(null)
          }}
        />
      )}
      <section className="row" data-testid={testId}>
        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8">
          <UserName userToDisplayInfo={{firstname, lastname, name}} />
          <div className="row">
            <Text modifier="small-no-padding" text={ausbildungsberufString} />
            {nachweisStatus && permissions.nachweis.verify && (
              <div className="row-min">
                <div className="horizontal-padding-4">
                  <Text modifier="small-no-padding" text="|" />
                </div>
                <AzubiStatusBadge
                  status={nachweisStatus.status}
                  numberOfMissingNachweise={nachweisStatus.numberOfMissingNachweise}
                />
              </div>
            )}
          </div>
        </div>
        {renderButtons()}
        <NachweisListe
          key={userId}
          azubiId={userId.toString()}
          ausbildungsnachweise={ausbildungsnachweise}
          canVerify
          modifier={modifier}
        />
      </section>
    </>
  )
}

NachweisListeAusbilderPerAzubi.propTypes = {
  userId: PropTypes.number,
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  ausbildungsberufString: PropTypes.string,
  ausbildungsnachweise: PropTypes.array,
  maxAusbildungsnachweisNummer: PropTypes.number,
  addDetailsLink: PropTypes.bool,
  testId: PropTypes.string,
  nachweisStatus: PropTypes.object,
}

export default NachweisListeAusbilderPerAzubi
